import { RepairReceivablesSheet } from './views';

export default {
  list: RepairReceivablesSheet,
  name: 'repair-receivables-sheet',
  label: 'Repairs - Receivable',
  to: '/repair-receivables-sheet',
};
